import { ContinuousRecordCreateDialogStore } from './continuous-record-create-dialog.store';
import { AfterViewInit, Component, inject, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { WorkContinuousRecordComponent } from '../../../work/work-continuous-record/work-continuous-record.component';
import { WorkGridItemObject } from '@it2go/types';
import {
    WorkDataContinuousRecordObject,
} from '@libs/types/src/services/object-type/work/work-data-continuous-record.object';

@Component({
    selector: 'app-continuous-record-create-dialog',
    templateUrl: './continuous-record-create-dialog.component.html',
    styleUrl: './continuous-record-create-dialog.component.scss',
    providers: [ContinuousRecordCreateDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        WorkContinuousRecordComponent,
    ],
})
export class ContinuousRecordCreateDialogComponent extends BaseDialogComponent implements AfterViewInit {

    public readonly store = inject(ContinuousRecordCreateDialogStore);
    public readonly continuousRecordFormComponent = viewChild<WorkContinuousRecordComponent>('continuousRecordForm');

    protected item: WorkGridItemObject<WorkDataContinuousRecordObject> | null = null;

    constructor() {
        super();

        this.item = this.dialogConfig.data.item;
    }

    public ngAfterViewInit(): void {
        if (this.item) {
            this.continuousRecordFormComponent()?.setData(this.item);
        }
    }

    public override async save(): Promise<void> {
        await this.continuousRecordFormComponent()?.save();
        this.dialogRef.close();
    }
}
